import { Button } from '../../../shared/ui/button';
import { Card } from '../../../shared/ui/layout';

// Board 16, "Has problems with nothing to show": the filter is deliberately left on, so a
// new failure is the first thing that appears here — this is not the generic no-match state.
export const ProblemsEmptyState = ({ onShowAll }: { onShowAll: () => void }) => (
  <Card className="mx-auto max-w-form text-center">
    <p className="text-data text-primary">Nothing is failing</p>
    <p className="mt-2 text-meta text-muted">
      No flow ran into a problem in the last 24 hours. The filter stays on, so a new one shows up
      here first.
    </p>
    <Button size="sm" variant="secondary" className="mt-3" onClick={onShowAll}>
      Show all flows
    </Button>
  </Card>
);
